// extracted by mini-css-extract-plugin
module.exports = {"text":"heroSkins-xlarge-text-7c542eb8"};